import { AjaxWrapper, HttpMethod } from 'generic/ajaxWrapper'
import { CommunityBillingInfo } from 'shared_server_client/types/billing_plan'

export const getProductSubscription = (communityId: string): Promise<CommunityBillingInfo> => {
  const url: string = AjaxWrapper.getServerUrl() + `/billing-plans/${communityId}`
  return AjaxWrapper.ajax(url, HttpMethod.GET, {})
}
